import React, { useState, useEffect, useRef } from 'react';
import { useController, useForm } from 'react-hook-form';
import classNames from 'classnames/bind';

import InputMask from 'react-input-mask';

import styles from './style.module.scss';
import {isMd} from "../../api/api";
const cx = classNames.bind(styles);

const PhoneInput = (props) => {
    const { field } = useController(props);
    const { register } = useForm();

    const [focus, setFocus] = useState(props.setFocus);
    const firstNameRef = useRef(null);
    const { ref } = register(props.name);

    const required = props?.rules?.required;

    useEffect(() => {
        if (field.value) {
            setFocus(true);
        }
        if (field.value === '' || field.value === '+380-') {
            setFocus(false);
        }
    }, [field.value]);

    return (
        <div className={props.disabled ? cx('disabled') : ''}>
            <div
                className={props.errors ? cx('inputWrap', 'error') : cx('inputWrap')}
            >
                <div className={focus ? cx('label', 'focus') : cx('label')}>
                    {props.label}{' '}
                    {required && !props.disabled ? (
                        <span className={cx('required')}>*</span>
                    ) : null}
                </div>
                <InputMask
                    {...props}
                    {...field}
                    mask={isMd ? null : "+380 99 999 99 99"}
                    maskChar={null}
                    value={field.value}
                    onChange={(e) => {
                        let value = e.target.value;

                        if (isMd) {
                            let val = e.target.value.replace(/\D/g, '');

                            if (val.length > 11) val = val.slice(0, 11);

                            value = '+' + val;
                        }

                        field.onChange(value);
                    }}
                    ref={(e) => {
                        ref(e);
                        firstNameRef.current = e;
                    }}
                    onFocus={() => setFocus(true)}
                    onBlur={() => !field.value && setFocus(false)}
                    className={focus ? cx('input', 'focus') : cx('input')}
                />

            </div>
            {props.errors && (
                <p className={cx('errorName')}>{props.errors?.message}</p>
            )}
        </div>
    );
};

export default PhoneInput;
